"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styled_components_1 = require("styled-components");
var ResizeHandle_1 = require("./ResizeHandle");
var RotateHandle_1 = require("./RotateHandle");
var dom_1 = require("./utils/dom");
var misc_1 = require("./utils/misc");
var initialState = {
    scale: 1,
};
var TransformBox = /** @class */ (function (_super) {
    __extends(TransformBox, _super);
    function TransformBox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = initialState;
        /**
         * Determine how much visual elements like handles and borders need to be scaled
         * in order to nullify any scale done to the container or its ancestors.
         */
        _this.calculateScale = function () {
            var refHandlers = _this.props.refHandlers;
            var containerRef = refHandlers.container;
            if (!containerRef.current) {
                return;
            }
            var containerScale = dom_1.scaleOfElement(containerRef.current);
            var scale = 1 / containerScale;
            if (_this.state.scale === scale) {
                return;
            }
            _this.setState({ scale: scale });
        };
        return _this;
    }
    TransformBox.prototype.componentDidMount = function () {
        this.calculateScale();
    };
    TransformBox.prototype.componentDidCatch = function () {
        this.calculateScale();
    };
    TransformBox.prototype.render = function () {
        var _a = this.props, position = _a.position, refHandlers = _a.refHandlers, resizable = _a.resizable, rotatable = _a.rotatable, style = _a.style, rest = __rest(_a, ["position", "refHandlers", "resizable", "rotatable", "style"]);
        var scale = this.state.scale;
        return (React.createElement(Root, __assign({}, rest, { ref: refHandlers.dnd, scale: scale, style: __assign(__assign({}, style), { height: "" + position.height, left: "" + position.left, top: "" + position.top, transform: "rotate(" + position.rotation + ")", width: "" + position.width }) }),
            resizable &&
                misc_1.calculateResizeObservableConfigs(Array.isArray(resizable) ? resizable : undefined).map(function (resizablePosition) { return (React.createElement(ResizeHandle_1.default, { key: resizablePosition.refHandlerName, ref: refHandlers[resizablePosition.refHandlerName], top: resizablePosition.top, right: resizablePosition.right, bottom: resizablePosition.bottom, left: resizablePosition.left, rotation: parseInt(position.rotation, 10), style: { transform: "scale(" + scale + ")" } })); }),
            rotatable &&
                misc_1.calculateRotateObservableConfigs().map(function (rotatablePosition) { return (React.createElement(RotateHandle_1.default, { key: rotatablePosition.refHandlerName, ref: refHandlers[rotatablePosition.refHandlerName], top: rotatablePosition.top, right: rotatablePosition.right, bottom: rotatablePosition.bottom, left: rotatablePosition.left, style: { transform: "scale(" + scale + ")" } })); })));
    };
    return TransformBox;
}(React.Component));
exports.TransformBox = TransformBox;
var Root = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    box-sizing: border-box;\n    border: ", "px dotted rgba(233, 30, 99, 0.5);\n    position: absolute;\n    z-index: 1000;\n"], ["\n    box-sizing: border-box;\n    border: ", "px dotted rgba(233, 30, 99, 0.5);\n    position: absolute;\n    z-index: 1000;\n"])), function (props) { return props.scale; });
exports.default = TransformBox;
var templateObject_1;
//# sourceMappingURL=TransformBox.js.map